import Topic from "./topic/topic";
import useTopics from "./use-topics";
import { MentorshipPlanTopicTransformed } from "../../mentorship-curriculum/types/mentorship-plan";
import GrayDotIcon from "assets/icons/mentorship-plan-varint-b/gray-dot-icon.svg";

type TopicsProps = {
  curriculumStats?: {
    sessions: number;
    subTopics: number;
    studyMaterials: number;
  };
  groupedTopicsLength: number;
  groupMentorTopicsBySubject: Record<string, MentorshipPlanTopicTransformed[]>;
  defaultAnalyticsPayload: any;
};

const Topics = ({
  groupedTopicsLength,
  curriculumStats,
  groupMentorTopicsBySubject,
  defaultAnalyticsPayload,
}: TopicsProps) => {
  const { listOfSubjects, expandTopics, toggleExpandTopics } = useTopics({
    defaultAnalyticsPayload,
    groupMentorTopicsBySubject,
  });

  return (
    <div>
      <div className="space-y-8">
        <div className="hidden items-center justify-between md:flex">
          <div className="flex items-center gap-3">
            <p className="text-[15px] font-medium text-[#525866] -tracking-[0.225px]">
              {groupedTopicsLength} Topics
            </p>
            <img src={GrayDotIcon} alt="dot.svg" />
            <p className="text-[15px] font-medium text-[#525866] -tracking-[0.225px]">
              {curriculumStats?.subTopics} Sub Topics
            </p>
            {curriculumStats?.studyMaterials ? (
              <>
                <img src={GrayDotIcon} alt="dot.svg" />
                <p className="text-[15px] font-medium text-[#525866] -tracking-[0.225px]">
                  {curriculumStats?.studyMaterials} Study Material
                </p>
              </>
            ) : (
              <></>
            )}
            <img src={GrayDotIcon} alt="dot.svg" />
            <p className="text-[15px] font-medium text-[#525866] -tracking-[0.225px]">
              {curriculumStats?.sessions} Sessions
            </p>
          </div>
          <button
            onClick={() =>
              toggleExpandTopics(listOfSubjects, !(expandTopics.length > 0))
            }
            className="text-sm leading-[17px] font-medium text-[#0E121B] -tracking-[0.21px] underline"
          >
            {expandTopics.length > 0
              ? "Collapse All Topics"
              : "Expand All Topics"}
          </button>
        </div>
        <div className="space-y-5">
          {Object.keys(groupMentorTopicsBySubject)?.map((subject) => (
            <Topic
              key={subject}
              subject={subject}
              groupMentorTopicsBySubject={groupMentorTopicsBySubject}
              expandTopics={expandTopics}
              toggleExpandTopics={toggleExpandTopics}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default Topics;
